export default {
  title_1: 'Instrucciones',
  operation_desc_1: 'La carcasa de aleación de aluminio protege la billetera de daños',
  operation_desc_2: 'Botón IZQUIERDA',
  operation_desc_3: 'Moverse a la izquierda en la pantalla o volver a la página anterior',
  operation_desc_4: 'Botón ABAJO',
  operation_desc_5: 'Moverse hacia abajo en la pantalla',
  operation_desc_6: 'Pantalla de 2 pulgadas para mostrar transacciones relacionadas',
  operation_desc_7: 'Botón ARRIBA',
  operation_desc_8: 'Moverse hacia arriba en la pantalla',
  operation_desc_9: 'Botón DERECHA',
  operation_desc_10: 'Moverse a la derecha en la pantalla o confirmar acciones',
  operation_desc_11: 'Botón OK',
  operation_desc_12: 'Confirmar acciones o entrar al menú; mantener pulsado para encender/apagar',
  operation_desc_13: 'Type-C',
  operation_desc_14: 'Para cargar y actualizar el firmware',

  title_2: 'Cómo empezar con KeyPal',
  get_start_desc_1: 'Inicialización',
  get_start_desc_2: 'Mantén presionado "',
  get_start_desc_3: '" durante tres segundos para encender; se mostrará que KP_XXX no está activado.',
  get_start_desc_4: 'Pasos para activar (crear billetera):',
  get_start_desc_5: '1. Toca',
  get_start_desc_6: 'para entrar al menú principal.',
  get_start_desc_7: '2. Pulsa el botón abajo',
  get_start_desc_8: 'y selecciona "Create Wallet"',
  get_start_desc_9: '3. Haz una copia de seguridad y verifica las mnemotecnias en orden, y configura el PIN; el dispositivo quedará activado.',
  get_start_desc_10: 'Usa bolígrafo y papel o la caja mnemotécnica KEYPAL para el registro.',
  get_start_desc_11: 'Registra las mnemotecnias en orden y verifícalas',

  title_3: 'Cómo conectar KeyPal con TokenPocket',
  connect_desc_1: '1. Asegúrate de que el Bluetooth de KeyPal esté encendido: [Ajustes] - [Bluetooth].',
  connect_desc_2: '2. En TokenPocket, toca la billetera "',
  connect_desc_3: '" en la esquina superior derecha y, en la página "Seleccionar red", elige la billetera de hardware KeyPal.',
  connect_desc_4: '3. Selecciona "Agregar dispositivo". TokenPocket buscará dispositivos y podrás elegir el que coincida con el nombre Bluetooth actual.',
  connect_desc_4_2: '(Recordatorio: el nombre Bluetooth puede verse en [Acerca de] - [Información del dispositivo]. Si el cliente no encuentra el dispositivo correspondiente, reinicia el hardware y repite los pasos.',
  connect_desc_5: 'Tras conectarse correctamente, el icono de Bluetooth de KeyPal aparecerá en la parte superior derecha de la página de activos de TokenPocket.',
  connect_desc_6: 'Conectado correctamente',

  title_4: 'Crear billeteras en lote',
  batch_desc_1: '1. Conecta KeyPal a la aplicación TokenPocket por Bluetooth.',
  batch_desc_2: '2. Toca el icono de billetera de hardware con el indicador de Bluetooth en la esquina superior derecha de la app.',
  batch_desc_3: '3. Ve a "Gestión de KeyPal" y toca "Agregar billetera".',
  batch_desc_4: '4. En la página, toca "Agregar en lote" en la esquina superior derecha. Listo.',
  batch_desc_5: 'Para saber cómo conectar KeyPal y TokenPocket, consulta arriba',
  batch_desc_6: 'Toca para ver las billeteras en lote',

  title_5: 'Intercambio, transferencia, etc. — Firmar con PIN',
  exchange_desc_1: 'Conecta la billetera de hardware KeyPal a la app TokenPocket para realizar las siguientes operaciones:',
  exchange_desc_2: 'En las imágenes, los caracteres "*" que aparecen en la imagen más a la derecha de la primera fila corresponden a los números que aparecen en la segunda imagen de la segunda fila. Solo sigue los números mostrados en el dispositivo KeyPal para introducir el PIN que configuraste al crear la billetera.',
  exchange_desc_3: 'Introduce en el cliente según las posiciones donde KeyPal muestre los números',

  tutorial_title_1: '¿Cómo verificar tu dispositivo KeyPal?',
  tutorial_desc_1: 'Entra en la gestión del dispositivo y revisa la seguridad del dispositivo.',
  tutorial_title_2: '¿Cómo verificar que tu dirección pertenece a KeyPal?',
  tutorial_desc_2: 'Conecta KeyPal con TokenPocket y, paso a paso, selecciona "Receive" y "Test".',
  tutorial_title_3: '¿Cómo recibir tokens con KeyPal?',
  tutorial_desc_3: 'Conecta KeyPal con TokenPocket y selecciona "Receive".',
  tutorial_title_4: '¿Cómo enviar tokens con KeyPal?',
  tutorial_desc_4: 'Conecta KeyPal con TokenPocket y selecciona "Send" y "Transfer".',
  tutorial_title_5: '¿Cómo introducir el PIN al realizar una transacción?',
  tutorial_desc_5: ''
};
